import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, CardBody, Card, Table, Alert, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

//redux
import { values } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { setRequireCloseModal } from '../../../slices/personalProtectiveEquipment/reducer';
import { getPersonList, } from '../../../helpers/establishment/backend_helper';
import { deliverWarehouseItem, deliverWarehouseItemStockCheck, getEstablishmentTypeList, getPersonalProtectiveEquipment, getPersonalProtectiveEquipmentList, getPersonalProtectiveEquipmentStatusByCode, setPersonalProtectiveEquipmentPicked, updatePersonalProtectiveEquipment, uploadFile, uploadFoldersFile, } from '../../../slices/thunks';
import OSelect from '../../../Components/OElements/OSelect';
import { getWarehouseList } from '../../../helpers/warehouse/backend_helper';
import SimpleBar from 'simplebar-react';
import useLogoLoader from '../../../Components/Hooks/useLogoLoaderHooks';
import { generatePDF } from '../Document/PPEDocument';
import useFileType from '../../../Components/Hooks/useFileTypeHooks';
import useFolderPaths from '../../../Components/Hooks/useFolderPathsHooks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import OInput from '../../../Components/OElements/OInput';

const PersonalProtectiveEquipmentPick = ({ dataListSelect, handleToggleModalSelected, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();
	const { logoSrc } = useLogoLoader('login');

	const [folderPaths, setFolderPaths] = useState([]);
	const [selectedPPEList, setSelectedPPEList] = useState([]);
	const [selectedEstablishment, setSelectedEstablishment] = useState(null);
	const [selectedPerson, setSelectedPerson] = useState(null);
	const [loading, setLoading] = useState(false);
	const [typeDocument, setTypeDocument] = useState(null);

	const [fileName, setFileName] = useState('');
	const { file_type } = useFileType('GD');

	const selectorEstablishmentTypes = createSelector(
		state => state.EstablishmentTypes,
		data => ({
			itemEstablishmentTypeList: data.itemEstablishmentTypeList,
		})
	);

	const { itemEstablishmentTypeList, } = useSelector(selectorEstablishmentTypes);

	const selectorPersonalProtectiveEquipment = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
			itemPersonalProtectiveEquipmentDetail: data.itemPersonalProtectiveEquipmentDetail,
		})
	);

	const { isLoadingList, requireCloseModal, itemPersonalProtectiveEquipmentDetail } = useSelector(selectorPersonalProtectiveEquipment);

	const selectorItems = createSelector(
		state => state.WarehouseItems,
		data => ({
			isCheckStock: data.isCheckStock,
			isCheckStockOk: data.isCheckStockOk,
			checkStockErrors: data.checkStockErrors
		})
	);

	const {
		isCheckStock,
		isCheckStockOk,
		checkStockErrors
	} = useSelector(selectorItems);

	useEffect(() => {
		if(
			isOpen &&
			selectedPPEList?.length
		) {
			dispatch(deliverWarehouseItemStockCheck({personal_protective_equipment_ids: selectedPPEList}))
		}
	}, [isOpen, selectedPPEList])

	useEffect(() => {
		dispatch(getEstablishmentTypeList());
		dispatch(getPersonalProtectiveEquipmentStatusByCode('RTD'));
	}, []);

	useEffect(() => {
		if(dataListSelect?.length){
			setSelectedPPEList(dataListSelect.map(item => item._id));
		}
	}, [dataListSelect])


	const uploadDocument = async (file, folderPaths, fileTypeId, establishmentId) => {
		if (!(file instanceof File)) {
			throw new Error("El archivo seleccionado no es válido.");
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("file_type_id", fileTypeId);
		formData.append("establishment_id", establishmentId);

		folderPaths.forEach(path => formData.append("folder_paths", path));

		// console.log("FormData antes de la subida:");
		// for (let pair of formData.entries()) {
		// 	console.log(pair[0], pair[1]);
		// }

		try {
			const response = await dispatch(uploadFoldersFile(formData)).unwrap();
			return response;
		} catch (error) {
			console.error("Error uploading file:", error);
			throw error;
		}
	};

	// Función auxiliar para preparar la lista de transferencias
	async function buildTransferList(data) {
		const list = [];
		let hasError = false;
		debugger;

		for (const item of data.assigned_items) {
			try {
				const response = await dispatch(getWarehouseGroupExist({
					establishment_id: data.establishment_id,
					group_code: item.warehouse_group_code
				}));

				list.push({
					source_warehouse_code: item.warehouse_code,
					destination_warehouse_code: response.payload.group.warehouse_code,
					warehouse_item_id: item.warehouse_item_id,
					quantity: item.quantity
				});
			} catch (error) {
				hasError = true;
				console.error("Error al obtener grupo de almacén:", item, error);
			}
		}

		if (hasError) {
			toast.error('Hubo errores con algunos ítems. Verifique configuración de almacenes.');
			setLoading(false);
			return null;
		}

		return list;
	}


	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			pick_person_id: '',
			pick_date: '',
			pick_document_number: '',
			document: '',
			file: '',
		},
		validationSchema: Yup.object({
			pick_person_id: Yup.string().required('Campo requerido'),
			pick_date: Yup.string().required('Campo requerido'),
			pick_document_number: Yup.string().required('Campo requerido'),
			document: Yup.string().required('Campo requerido'),
			file: Yup.string().nullable(),
		}),
		onSubmit: async values => {
			setLoading(true);

			const folderPaths = dataListSelect.map((item) => {
				const establishmentType = itemEstablishmentTypeList.find((type) => type._id === item.establishment.establishment_type_id);
				const establishmentTypeName = establishmentType ? establishmentType.name : '';
				const folder = '/' + establishmentTypeName + '/' + (item.establishment.code_siep ? item.establishment.code_siep + ' - ' : '') + item.establishment.name + '/Abastecimiento/EPP/Retiro';
				return folder
			})
			
			try{
				const documents = await uploadDocument(values.document, folderPaths, file_type._id, null);
				const document = documents[documents.length - 1];

				await dispatch(deliverWarehouseItem({
					personal_protective_equipment_ids: selectedPPEList,
					pick: true,
					pick_person_id: values.pick_person_id,
					pick_date: values.pick_date,
					pick_document_id: document._id,
					pick_document_number: values.pick_document_number
				}))

				dispatch(getPersonalProtectiveEquipmentList());
				setLoading(false);
				dispatch(setRequireCloseModal(true));
				handleToggleModalSelected();
			} catch (error) {
				console.error(error);
				toast.error('Ocurrió un error al procesar la entrega.');
			} finally {
				setLoading(false);
			}
		}
	});

	const columns = useMemo(
		() => [
			{ header: 'Elemento', accessorKey: 'name', size: 'auto' },
			{ header: 'Talla', accessorKey: 'size', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'quantity', size: 'auto' },
			{ header: 'Unidad', accessorKey: 'unit_measurement_name', size: 'auto' },
			{ header: 'Código SAP', accessorKey: 'code_sap', size: 'auto' },
		],
	);

	const handleFileChange = (event) => {
		const file = event.currentTarget.files[0] || null;
		validation.setFieldValue("document", file);
		validation.setFieldValue("file", file);
		setFileName(file ? file.name : ''); // Guarda o limpia el nombre del archivo
	};



	const transformedData = useMemo(() => {
		if (!dataListSelect) return [];

		const groupedItems = {};

		dataListSelect.forEach(({ assigned_items, code }) => {
			assigned_items.forEach(({ name, quantity, unit_measurement_name, size, code_sap }) => {
				const key = `${name}-${size}-${unit_measurement_name}`;

				if (!groupedItems[key]) {
					groupedItems[key] = {
						name,
						quantity,
						unit_measurement_name,
						size,
						code_sap
					};
				} else {
					groupedItems[key].quantity += quantity;
				}
			});
		});

		return Object.values(groupedItems);
	}, [dataListSelect]);



	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<React.Fragment>
					{
						isCheckStock ? (
							<Alert color='primary'>
								<Spinner size='sm' className='me-2' />
								Estamos comprobando el stock de los items en bodega, por favor espere...
							</Alert>
						)
						: (
							!isCheckStockOk ? (
								<Alert color='danger'>
									<p className='mb-0'>
										<b>{checkStockErrors?.message}:</b>
									</p>

									{checkStockErrors?.errors?.length ? (
										<ul className='mt-2 mb-0'>
											{checkStockErrors.errors.map((item, index) => (
												<li key={index}>{item}</li>
											))}
										</ul>
									) : null}
								</Alert>
							) :
							null
						)
					}
				</React.Fragment>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={3}>
								<OSelect
									key={`pick_person_id${values.pick_person_id}` || ''}
									label='Persona que Retira'
									id='pick_person_id'
									name='pick_person_id'
									isRequired={true}
									value={validation.values.pick_person_id || ''}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									onSelect={setSelectedPerson}
									requestApi={() => getPersonList({})}
									validation={validation}
								/>
							</Col>
							<Col sm={3}>
								<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
									<DatePickerInput
										label={
											<span>
												Fecha de Retiro <span style={{ color: 'red' }}>*</span>
											</span>
										}
										id='pick_date'
										name='pick_date'
										placeholder="Seleccione una fecha"
										value={
											validation.values.pick_date
												? new Date(validation.values.pick_date)
												: null
										}
										onChange={(date) => { validation.setFieldValue("pick_date", date); }}
										onBlur={validation.handleBlur}
										valueFormat='DD-MM-YYYY'
										maxDate={new Date()}
										// minDate={new Date(new Date().setDate(new Date().getDate() - 10))} // Set minDate to 5 days before today
										error={
											validation.touched['pick_date'] && validation.errors['pick_date']
												? validation.errors['pick_date']
												: ''
										}
										clearable={true}
									/>
								</DatesProvider>
							</Col>
						</Row>
						<Row className='g-3 mt-2'>
							<Col lg={2} >
								<OInput
									name='pick_document_number'
									label='Nro. Guía de Despacho'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={7}>
								<Label for="document">Guía de Despacho <span style={{ color: 'red' }}>*</span></Label>
								<Input
									name='document'
									id='document'
									className='form-control'
									placeholder='Ingrese el documento'
									type='file'
									validate={{ required: { value: true } }}
									value={fileName ? undefined : ''} // Resetea el valor si no hay archivo
									onChange={handleFileChange}
									onBlur={validation.handleBlur}
									invalid={validation.touched.document && validation.errors.document ? true : false}
								/>
								{validation.touched.document &&
									validation.errors.document ? (
									<FormFeedback type='invalid'>
										{validation.errors.document}
									</FormFeedback>
								) : null}
							</Col>

						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row>
							<Col lg={12}>
								<SimpleBar style={{ maxHeight: "300px" }}>
									<ODataGrid
										enableTopToolbar={false}
										columns={columns}
										data={transformedData}
										nameFile={'items_para_retiro'}
									/>
								</SimpleBar>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody >
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModalSelected();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={loading || isCheckStock || !isCheckStockOk}
					>
						{loading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						Retirar Elementos de Protección Personal
					</button>
				</div>
			</div>
		</Form >
	);
};

export default PersonalProtectiveEquipmentPick;
